import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=6ca490bd&scoped=true"
import script from "./deviceInfo.vue?vue&type=script&lang=js"
export * from "./deviceInfo.vue?vue&type=script&lang=js"
import style0 from "./deviceInfo.vue?vue&type=style&index=0&id=6ca490bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca490bd",
  null
  
)

export default component.exports